import * as React from 'react';
import { useState, useEffect, memo } from "react";
import Spinner from "../components/spinner";
import type { PageSectionData } from "../page/content.types";
import RenderContent from "./renderContent";
import { renderContentToHtmlString } from "../helpers/renderContentToHtmlString.ts";
import { renderCssFromPageContent } from "./renderFunctionsCss.tsx";

type Props = Readonly<{
	pageContent: PageSectionData[];
}>;

function RenderContentWithCss({pageContent}: Props) {
	const [css, setCss] = useState("");

	useEffect(() => {
		setTimeout(() => {
			renderCssFromPageContent(pageContent, renderContentToHtmlString).then((newCss) => {
				setCss(newCss);
			});
		})
	}, [pageContent]);

	return (<>
		{pageContent !== null ? <RenderContent content={pageContent}/> : <div className="text-center my-16"><Spinner/></div>}
		{/*<Dump value={page}/>*/}
		<style>{css}</style>
	</>);
}

export default memo(RenderContentWithCss);
